import { styled } from 'baseui'

// `:empty` matters: a module that renders nothing (wrong country, no eligibility) must not leave a gap.
export const SidebarBlock = styled<'div', { $plain?: boolean; $rail?: boolean }>(
  'div',
  ({ $theme, $plain, $rail }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: $rail ? 'center' : 'flex-start',
    marginBottom: $plain || $rail ? 0 : '0.625rem',
    backgroundColor: $plain || $rail ? 'transparent' : $theme.colors.white,
    borderRadius: '0.5rem',
    ':empty': { display: 'none' },
  }),
)

// No display of its own, so the `hidden` attribute switches between the button and its rail icon.
export const CallbackSlot = styled('div', {
  width: '100%',
})

export const RightPanelColumn = styled<'div', { $expanded: boolean }>('div', ({ $theme, $expanded }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: $expanded ? 'flex-start' : 'center',
  flexGrow: 0,
  flexShrink: 0,
  width: $expanded ? '25%' : '3.5rem',
  paddingTop: $expanded ? 0 : '0.5rem',
  paddingBottom: $expanded ? 0 : '0.5rem',
  backgroundColor: $expanded ? 'transparent' : $theme.colors.white,
  borderRadius: '0.5rem',
}))

export const RightPanelToggleRow = styled<'div', { $expanded: boolean }>('div', ({ $expanded }) => ({
  display: 'flex',
  justifyContent: $expanded ? 'flex-end' : 'center',
  width: '100%',
  marginBottom: $expanded ? '0.625rem' : '0.25rem',
}))

export const PanelToggleButton = styled('button', ({ $theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '2.5rem',
  height: '1.75rem',
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  border: 0,
  borderRadius: '999px',
  backgroundColor: $theme.colors.bg050,
  color: $theme.colors.primary,
  cursor: 'pointer',
  transition: 'background-color 0.12s',
  ':hover': { backgroundColor: $theme.colors.bg150 },
  ':focus-visible': { outline: `2px solid ${$theme.colors.primary}`, outlineOffset: '2px' },
}))
